(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8888],{

/***/ 44294:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/[id]",
      function () {
        return __webpack_require__(70464);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 70464:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _id_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./layouts/shared.ts
var shared = __webpack_require__(7806);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/react-share/es/FacebookShareButton.js
var FacebookShareButton = __webpack_require__(16573);
;// CONCATENATED MODULE: ./node_modules/react-share/es/hocs/createIcon.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};

function createIcon(iconConfig) {
    var Icon = function (_a) {
        var bgStyle = _a.bgStyle, borderRadius = _a.borderRadius, iconFillColor = _a.iconFillColor, round = _a.round, size = _a.size, rest = __rest(_a, ["bgStyle", "borderRadius", "iconFillColor", "round", "size"]);
        return (react.createElement("svg", __assign({ viewBox: "0 0 64 64", width: size, height: size }, rest),
            round ? (react.createElement("circle", { cx: "32", cy: "32", r: "31", fill: iconConfig.color, style: bgStyle })) : (react.createElement("rect", { width: "64", height: "64", rx: borderRadius, ry: borderRadius, fill: iconConfig.color, style: bgStyle })),
            react.createElement("path", { d: iconConfig.path, fill: iconFillColor })));
    };
    Icon.defaultProps = {
        bgStyle: {},
        borderRadius: 0,
        iconFillColor: 'white',
        size: 64,
    };
    return Icon;
}

;// CONCATENATED MODULE: ./node_modules/react-share/es/FacebookIcon.js

var FacebookIcon = createIcon({
    color: '#3b5998',
    networkName: 'facebook',
    path: 'M34.1,47V33.3h4.6l0.7-5.3h-5.3v-3.4c0-1.5,0.4-2.6,2.6-2.6l2.8,0v-4.8c-0.5-0.1-2.2-0.2-4.1-0.2 c-4.1,0-6.9,2.5-6.9,7V28H24v5.3h4.6V47H34.1z',
});
/* harmony default export */ var es_FacebookIcon = (FacebookIcon);

// EXTERNAL MODULE: ./node_modules/react-share/es/utils/assert.js
var assert = __webpack_require__(25456);
// EXTERNAL MODULE: ./node_modules/react-share/es/utils/objectToGetParams.js
var objectToGetParams = __webpack_require__(86459);
// EXTERNAL MODULE: ./node_modules/react-share/es/hocs/createShareButton.js + 1 modules
var createShareButton = __webpack_require__(79075);
;// CONCATENATED MODULE: ./node_modules/react-share/es/TwitterShareButton.js



function twitterLink(url, _a) {
    var title = _a.title, via = _a.via, _b = _a.hashtags, hashtags = _b === void 0 ? [] : _b, _c = _a.related, related = _c === void 0 ? [] : _c;
    (0,assert/* default */.Z)(url, 'twitter.url');
    (0,assert/* default */.Z)(Array.isArray(hashtags), 'twitter.hashtags is not an array');
    (0,assert/* default */.Z)(Array.isArray(related), 'twitter.related is not an array');
    return ('https://twitter.com/share' +
        (0,objectToGetParams/* default */.Z)({
            url: url,
            text: title,
            via: via,
            hashtags: hashtags.length > 0 ? hashtags.join(',') : undefined,
            related: related.length > 0 ? related.join(',') : undefined,
        }));
}
var TwitterShareButton = (0,createShareButton/* default */.Z)('twitter', twitterLink, function (props) { return ({
    hashtags: props.hashtags,
    title: props.title,
    via: props.via,
    related: props.related,
}); }, {
    windowWidth: 550,
    windowHeight: 400,
});
/* harmony default export */ var es_TwitterShareButton = (TwitterShareButton);

;// CONCATENATED MODULE: ./node_modules/react-share/es/EmailShareButton.js


function emailLink(url, _a) {
    var subject = _a.subject, body = _a.body, separator = _a.separator;
    return 'mailto:' + (0,objectToGetParams/* default */.Z)({ subject: subject, body: body ? body + separator + url : url });
}
var EmailShareButton = (0,createShareButton/* default */.Z)('email', emailLink, function (props) { return ({
    subject: props.subject,
    body: props.body,
    separator: props.separator || ' ',
}); }, {
    openShareDialogOnClick: false,
    onClick: function (_, link) {
        window.location.href = link;
    },
});
/* harmony default export */ var es_EmailShareButton = (EmailShareButton);

;// CONCATENATED MODULE: ./node_modules/react-share/es/EmailIcon.js

var EmailIcon = createIcon({
    color: '#7f7f7f',
    networkName: 'email',
    path: 'M17,22v20h30V22H17z M41.1,25L32,32.1L22.9,25H41.1z M20,39V26.6l12,9.3l12-9.3V39H20z',
});
/* harmony default export */ var es_EmailIcon = (EmailIcon);

;// CONCATENATED MODULE: ./features/journal/article-share.tsx





var ArticleShare = function(param) {
    var url = param.url, title = param.title;
    var ref = (0,react.useState)(""), status = ref[0], setStatus = ref[1];
    var copy = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var _e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            navigator.clipboard.writeText(url)
                        ];
                    case 1:
                        _state.sent();
                        setStatus("Đ\xe3 sao ch\xe9p li\xean kết");
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _e = _state.sent();
                        setStatus("Kh\xf4ng thể sao ch\xe9p. H\xe3y sao ch\xe9p địa chỉ tr\xean tr\xecnh duyệt.");
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function copy() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-flex tw-flex-wrap tw-items-center tw-gap-3 tw-text-sm tw-text-jr-mute",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: "Chia sẻ:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FacebookShareButton/* default */.Z, {
                url: url,
                title: "Chia sẻ Facebook",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_FacebookIcon, {
                    size: 32,
                    round: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_TwitterShareButton, {
                url: url,
                title: title,
                "aria-label": "Chia sẻ X",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "tw-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-full tw-bg-black tw-text-white",
                    "aria-hidden": "true",
                    children: "\uD835\uDD4F"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_EmailShareButton, {
                url: url,
                subject: title,
                "aria-label": "Chia sẻ qua email",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_EmailIcon, {
                    size: 32,
                    round: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                onClick: copy,
                className: "tw-rounded-full tw-border tw-border-jr-line tw-bg-white tw-px-3 tw-py-1.5 tw-text-jr-green",
                children: "Sao ch\xe9p li\xean kết"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                    var e;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!navigator.share) return [
                                    3,
                                    5
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    navigator.share({
                                        title: title,
                                        url: url
                                    })
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                if (e.name !== "AbortError") setStatus("Kh\xf4ng thể mở menu chia sẻ.");
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                setStatus("Sao ch\xe9p li\xean kết để gửi qua Messenger hoặc Zalo.");
                                _state.label = 6;
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                }),
                className: "tw-rounded-full tw-border tw-border-jr-line tw-bg-white tw-px-3 tw-py-1.5 tw-text-jr-green",
                children: "Chia sẻ th\xeam"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                role: "status",
                className: "tw-w-full tw-text-xs",
                children: status
            })
        ]
    });
};

// EXTERNAL MODULE: ./features/journal/text.ts
var journal_text = __webpack_require__(16356);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 25 modules
var esm = __webpack_require__(10268);
// EXTERNAL MODULE: ./components/ui/MetaTag/index.tsx
var MetaTag = __webpack_require__(42031);
// EXTERNAL MODULE: ./components/ui/JsonLd/index.tsx
var JsonLd = __webpack_require__(59904);
// EXTERNAL MODULE: ./constants/business.ts
var business = __webpack_require__(56154);
// EXTERNAL MODULE: ./constants/offTopicArticles.ts
var offTopicArticles = __webpack_require__(94069);
// EXTERNAL MODULE: ./features/article/partial/RelatedProduct.tsx + 1 modules
var RelatedProduct = __webpack_require__(65055);
// EXTERNAL MODULE: ./features/article/partial/ambassador-registration/AmbassadorRegistrationForm.tsx + 1 modules
var AmbassadorRegistrationForm = __webpack_require__(99101);
// EXTERNAL MODULE: ./features/journal/const.ts
var journal_const = __webpack_require__(89365);
// EXTERNAL MODULE: ./features/journal/components.tsx + 3 modules
var components = __webpack_require__(41046);
;// CONCATENATED MODULE: ./features/journal/article.tsx

















var SITE = business/* BUSINESS.appUrl */.aL.appUrl;
var plain = journal_text/* plainText */.Kd;
/** Trang bài viết trong khung An Thư Journal: cùng header/footer với /tin-tuc/, có tiêu đề hiển thị và đường quay về. */ var JournalArticleLayout = function(param) {
    var article = param.article, products = param.products, newArticles = param.newArticles, topicSlug = param.topicSlug, cover = param.cover;
    var ref, ref1;
    var t = (0,esm/* useTranslation */.$G)([
        "layout"
    ]).t;
    var yoast_head_json = article.yoast_head_json, title = article.title, thumbnail_url = article.thumbnail_url, content = article.content;
    var topic = topicSlug ? journal_const/* TOPIC_BY_SLUG */.wp[topicSlug] : undefined;
    var heading = plain(title.rendered);
    var url = "".concat(SITE, "/article/").concat(article.slug);
    var isPress = (ref = article.categories) === null || ref === void 0 ? void 0 : ref.includes(27);
    var originalSource = (0,journal_text/* pressSource */.Id)(content.rendered, isPress);
    var source = originalSource || (0,journal_text/* articleSource */.VM)(article.link);
    var crumbs = [
        {
            label: "Trang chủ",
            href: "/"
        },
        {
            label: "Tin tức",
            href: "/tin-tuc/"
        }, 
    ].concat((0,_to_consumable_array/* default */.Z)(isPress ? [
        {
            label: "B\xe1o ch\xed",
            href: "/tin-tuc/bao-chi/"
        }
    ] : []), (0,_to_consumable_array/* default */.Z)(topic ? [
        {
            label: topic.title,
            href: (0,journal_const/* topicHref */.hR)(topic.slug)
        }
    ] : []), [
        {
            label: heading
        }, 
    ]);
    var more = (newArticles || []).filter(function(n) {
        return n.id !== article.id;
    }).sort(function(a, b) {
        var overlap = function(item) {
            return (item.categories || []).filter(function(category) {
                var ref;
                return (ref = article.categories) === null || ref === void 0 ? void 0 : ref.includes(category);
            }).length;
        };
        return overlap(b) - overlap(a);
    }).slice(0, 3).map(function(n) {
        return {
            id: n.id,
            slug: n.slug,
            title: plain(n.title.rendered),
            excerpt: "",
            date: n.date,
            image: n.thumbnail_url || null,
            topics: []
        };
    });
    var navKey = isPress ? "bao-chi" : topic && [
        "kim-cuong",
        "trang-suc"
    ].includes(topic.slug) ? topic.slug : "kien-thuc";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* JournalShell */.C2, {
        activeKey: navKey,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTag/* default */.Z, {
                title: heading,
                noindex: (0,offTopicArticles/* isArticleNoindex */.o)(article),
                description: yoast_head_json === null || yoast_head_json === void 0 ? void 0 : yoast_head_json.description,
                seo: {
                    title: heading,
                    description: yoast_head_json === null || yoast_head_json === void 0 ? void 0 : yoast_head_json.description,
                    keywords: (ref1 = article.acf) === null || ref1 === void 0 ? void 0 : ref1.keywords
                },
                image: thumbnail_url
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(JsonLd/* default */.Z, {
                schema: [
                    (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        "@context": "https://schema.org",
                        "@type": "Article",
                        headline: heading
                    }, originalSource ? {
                        citation: originalSource.href
                    } : {}), {
                        image: thumbnail_url,
                        datePublished: article.date,
                        dateModified: article.modified,
                        author: {
                            "@type": "Organization",
                            "@id": business/* BUSINESS.id */.aL.id,
                            name: business/* BUSINESS.name */.aL.name
                        },
                        publisher: {
                            "@type": "Organization",
                            name: business/* BUSINESS.name */.aL.name,
                            logo: {
                                "@type": "ImageObject",
                                url: business/* BUSINESS.logo */.aL.logo
                            }
                        },
                        mainEntityOfPage: {
                            "@type": "WebPage",
                            "@id": url
                        }
                    }),
                    {
                        "@context": "https://schema.org",
                        "@type": "BreadcrumbList",
                        itemListElement: [
                            {
                                "@type": "ListItem",
                                position: 1,
                                name: "Trang chủ",
                                item: SITE
                            },
                            {
                                "@type": "ListItem",
                                position: 2,
                                name: "Tin tức",
                                item: "".concat(SITE, "/tin-tuc/")
                            }, 
                        ].concat((0,_to_consumable_array/* default */.Z)(isPress ? [
                            {
                                "@type": "ListItem",
                                position: 3,
                                name: "B\xe1o ch\xed",
                                item: "".concat(SITE, "/tin-tuc/bao-chi/")
                            }
                        ] : []), (0,_to_consumable_array/* default */.Z)(topic ? [
                            {
                                "@type": "ListItem",
                                position: isPress ? 4 : 3,
                                name: topic.title,
                                item: "".concat(SITE).concat((0,journal_const/* topicHref */.hR)(topic.slug))
                            }
                        ] : []), [
                            {
                                "@type": "ListItem",
                                position: 3 + (isPress ? 1 : 0) + (topic ? 1 : 0),
                                name: heading,
                                item: url
                            }, 
                        ])
                    }, 
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Breadcrumb */.aG, {
                items: crumbs
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-mx-auto tw-w-full tw-max-w-[1296px] tw-px-5 md:tw-px-8 tw-grid tw-grid-cols-1 ".concat(more.length ? "lg:tw-grid-cols-[minmax(0,1fr)_280px] xl:tw-grid-cols-[minmax(0,1fr)_320px]" : "", " tw-gap-10 xl:tw-gap-16"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                        className: "tw-min-w-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                                className: "tw-w-full tw-pb-8",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Eyebrow */.j4, {
                                        children: isPress ? "B\xc1O CH\xcd" : topic ? topic.tag : "TIN TỨC"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: "tw-font-jr tw-mt-4 tw-mb-0 tw-text-[30px] md:tw-text-[44px] tw-font-normal tw-leading-[1.2] [text-wrap:balance]",
                                        children: heading
                                    }),
                                    dayjs_min_default()(article.date).isValid() && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "tw-mt-4 tw-mb-0 tw-text-[14px] tw-text-jr-mute",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("time", {
                                            dateTime: article.date,
                                            children: dayjs_min_default()(article.date).format("DD/MM/YYYY")
                                        })
                                    }),
                                    source && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "tw-mt-2 tw-mb-0 tw-text-sm tw-text-jr-mute",
                                        children: [
                                            "Nguồn: ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                href: source.href,
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                className: "tw-text-jr-green hover:tw-underline",
                                                children: [
                                                    source.label,
                                                    " ↗"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            cover && thumbnail_url && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-w-full tw-pb-8",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: thumbnail_url,
                                    alt: heading,
                                    className: "tw-w-full tw-h-auto tw-max-h-[520px] tw-object-cover"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tw-w-full",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "tw-text-jr-ink tw-w-full tw-max-w-none tw-prose tw-prose-sm md:tw-prose-base lg:tw-prose-lg content-article",
                                        dangerouslySetInnerHTML: {
                                            __html: content.rendered
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "tw-mt-8 tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-4 tw-border-t tw-border-jr-line tw-pt-6",
                                        children: [
                                            topic && /*#__PURE__*/ (0,jsx_runtime.jsxs)(components.A, {
                                                href: (0,journal_const/* topicHref */.hR)(topic.slug),
                                                className: "tw-text-[15px] tw-font-medium tw-text-jr-green hover:tw-underline",
                                                children: [
                                                    "← Về chuy\xean đề ",
                                                    topic.title
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleShare, {
                                                url: url,
                                                title: heading
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    more.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("aside", {
                        "aria-label": "B\xe0i viết li\xean quan",
                        className: "tw-min-w-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "lg:tw-sticky lg:tw-top-6 tw-border-t lg:tw-border-t-0 tw-border-jr-line tw-pt-6 lg:tw-pt-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Eyebrow */.j4, {
                                    children: "KH\xc1M PH\xc1 TH\xcaM"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "tw-font-jr tw-text-2xl tw-mt-3 tw-mb-6",
                                    children: "B\xe0i viết li\xean quan"
                                }),
                                more.map(function(item) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components.A, {
                                        href: "/article/".concat(item.slug, "/"),
                                        className: "tw-block tw-mb-6 tw-pb-6 tw-border-b tw-border-jr-line tw-group",
                                        children: [
                                            item.image && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: item.image,
                                                alt: "",
                                                loading: "lazy",
                                                className: "tw-w-full tw-aspect-[16/9] tw-object-cover tw-mb-3"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "tw-text-xs tw-text-jr-mute",
                                                children: dayjs_min_default()(item.date).format("DD/MM/YYYY")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                className: "tw-font-jr tw-text-xl tw-leading-snug tw-mt-2 tw-mb-0 group-hover:tw-text-jr-green",
                                                children: item.title
                                            })
                                        ]
                                    }, item.id);
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-mx-auto tw-w-full tw-max-w-[1296px] tw-px-5 md:tw-px-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AmbassadorRegistrationForm/* default */.Z, {
                        article: article
                    }),
                    !!(products === null || products === void 0 ? void 0 : products.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-mt-10 tw-hidden lg:tw-block",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedProduct/* default */.Z, {
                            products: products,
                            t: t
                        })
                    })
                ]
            }),
            more.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Section */.$0, {
                className: "!tw-pb-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* SectionHead */.Ry, {
                        title: "Tin mới nhất tại An Thư"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ArticleGrid */.dz, {
                        items: more,
                        showDate: true
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./pages/article/[id]/index.tsx






var BlogPage = function(props) {
    var ref;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(JournalArticleLayout, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        cover: ((ref = props.article.acf) === null || ref === void 0 ? void 0 : ref.layout) === shared/* NewsLayout.PromotionsLayout */.JD.PromotionsLayout
    }));
};
var __N_SSP = true;
/* harmony default export */ var _id_ = (BlogPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [719,2031,8276,4904,9205,9774,2888,179], function() { return __webpack_exec__(44294); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);